<div class="overview-reit-update">
  <klt-section
    title="REIT updates"
    type="pagination"
    (paginate)="pageActive = $event; pagination()"
    [length]="reits.length"
    [showTitleScroll]="showTitleScroll"
    [showPagination]="showPagination"
    >
    <div class="reit-box">
      @for (reit of paginateReits; track reit) {
        <div class="reit-item">
          <div class="date">
            {{ reit.date }}
          </div>
          <div class="title">
            {{ reit.title }}
          </div>
          <div class="description" [kltAsHtml]="reit.description"></div>
          @if (reit.showMore) {
            <klt-link-action
              text="Read more"
              [iconRight]="'down'"
            ></klt-link-action>
          }
        </div>
      }
    </div>
  </klt-section>
</div>
